/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import { Notifications } from '@tmna-ct/ipapps-core-js';
import styles from './styles';

const optsBrowser = {
  pattern: '@long',
  uri: 'com.toyota.app://?app_id =com.toyota.notifiction&title=Information',
};

const optsNative = {
  body: [
    {
      en: 'Break Suggested',
      es: 'pausa sugerida',
      fr: 'pause suggérée',
    },
  ],
  comment: [
    {
      en: 'suggestions',
      es: 'sugerencias',
      fr: 'suggestions',
    },
  ],
  icon: '@icon.System.Alert',
  icon_bg: '@fillPrimary1',
  action: [
    {
      icon: '@icon.Phone.Default.primary1',
      link: 'tel:+15551234567',
    },
    {
      icon: '@icon.navigation.Default',
      link:
        'com.toyota.navi://setDestination?lon=96.841184&lat=33.081601&name=starbucks&address=hogehoge&phone=+15550123456&poi_id=abcdefgh',
    },
  ],
};

class NotificationServices extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  handleClickNative() {
    let notifify = new Notifications();
    notifify.native(optsNative);
  }

  handleClickBrowser() {
    let notifify = new Notifications();
    notifify.browser(optsBrowser);
  }
  render() {
    const {t, classes: { container, separation }} = this.props;
    return (
      <div className={container}>
        <h3 className={separation}>{t('screens.Notifications.title')}</h3>
        <p className={separation}>{t('screens.Notifications.description')}</p>
        <Button variant="contained" className={separation} onClick={() => this.handleClickNative()}>
          {t('screens.Notifications.native')}
        </Button>
        <Button variant="contained" className={separation} onClick={() => this.handleClickBrowser()}>
          {t('screens.Notifications.browser')}
        </Button>
      </div>
    );
  }
}

NotificationServices.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(NotificationServices));
